import Vue from 'vue';
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import Vuetify from 'vuetify'
import 'element-ui/lib/theme-chalk/index.css';

//import UploaderPlugin  from '@syncfusion/ej2-vue-inputs';
import locale from 'element-ui/lib/locale/lang/en'
import BlockUIService from './Shared/BlockUIService.js';

import App from './App.vue';
import Layout from './components/Layout/Layout.vue';
import ComingSoon from './components/Layout/ComingSoon/ComingSoon.vue';
import GeneralSettings from './components/Settings/GeneralSettings.vue'; // LE-027
import Login from './components/Login/Login.vue';

import DataService from './Shared/DataService';
import Helper from './Shared/Helper';
import TripChatHubService from './Shared/TripChatHubService';

import VueEllipseProgress from 'vue-ellipse-progress';



//Dashboard
import Home from './components/Home/Home.vue';
// Dashboard cleanup 2026-06-02: the 5 dead Home/* clones were replaced by real
// pages — /Cards & /Charging now use VoucherCards pages, /SubscriptionsDashboard
// & /WalletsDashboard use new Financial overview pages, and /Sales uses the
// existing RevenueDashboard (imported below).
import Cards from './components/VoucherCards/CardsList/CardsList.vue';
import Charging from './components/VoucherCards/Charging/Charging.vue';
import Events from './components/Home/Events/Events.vue';
import Statistic from './components/Home/Statistic/Statistic.vue';
import SubscriptionsDashboard from './components/Financial/SubscriptionsOverview/SubscriptionsOverview.vue';
import WalletsDashboard from './components/Financial/WalletsOverview/WalletsOverview.vue';
// Students
import Students from './components/Students/Students.vue';

// Students
import Parents from './components/Parents/Parents.vue';
//Schools
import Schools from './components/Schools/Schools.vue';
import SchoolsSuspend from './components/Schools/Suspend/Suspend.vue';
import SchoolsUsers from './components/Schools/Users/Users.vue';
import SchoolsWallets from './components/Schools/Wallets/Wallets.vue';

//Passengers
import Passengers from './components/Passengers/Passengers.vue';

import SuspendedPassengers from './components/SuspendedPassengers/SuspendedPassengers.vue';

//Drivers
import Drivers from './components/Drivers/Drivers.vue';
import SuspendedDrivers from './components/SuspendedDrivers/SuspendedDrivers.vue';
import DriversRatings from './components/Drivers/Ratings/Ratings.vue';

//Trips
import Trips from './components/Trips/Trips.vue';
import CurrentRequests from './components/CurrentRequests/CurrentRequests.vue';
import CurrentTrips from './components/CurrentTrips/CurrentTrips.vue';
import SharedTrips from './components/SharedTrips/SharedTrips.vue';
import SchoolTrips from './components/SchoolTrips/SchoolTrips.vue';
import ScheduledTrips from './components/ScheduledTrips/ScheduledTrips.vue';

//Contract trips (الرحلات التعاقدية) — six super-admin pages backing the
// contract-trips feature: requests & quotes, contracts, companies/employees,
// the 30-day plan, today's board, and contract invoices. Lazy-loaded because
// main.js already imports ~70 components eagerly and these six are large.
const ContractRequests = () => import('./components/Contracts/ContractRequests.vue');
const Contracts = () => import('./components/Contracts/Contracts.vue');
const ContractCompanies = () => import('./components/Contracts/ContractCompanies.vue');
const ContractPlanning = () => import('./components/Contracts/ContractPlanning.vue');
const ContractTripsToday = () => import('./components/Contracts/ContractTripsToday.vue');
const ContractInvoices = () => import('./components/Contracts/ContractInvoices.vue');

// Menu cleanup 2026-07-25: the 12 Classes/* pages were an e-learning leftover —
// every one of them imported the SAME Users list markup and called
// GET api/admin/Users/Get, so they were 12 identical copies of /Users reachable
// only by typing the URL. Deleted with their folders.

//Financial
// /Financial and /FinancialWithdrawing called the identical endpoint with the
// identical arguments and differed only in their action buttons, so both routes
// now resolve to one tabbed page (اعتماد السحب | القيود اليدوية).
import FinancialHub from './components/Financial/FinancialHub.vue';
import FinancialSubscriptions from './components/Financial/Subscriptions/Subscriptions.vue';
import FinancialRecharge from './components/Financial/Recharge/Recharge.vue';
import FinancialTracker from './components/Financial/Tracker/Tracker.vue';

import WalletPurchases from './components/Financial/WalletPurchases/WalletPurchases.vue';

//VoucherCards
import VoucherCards from './components/VoucherCards/VoucherCards.vue';
import VoucherCardsDashboard from './components/VoucherCards/Dashboard/Dashboard.vue';
import VoucherCardsDistributors from './components/VoucherCards/Distributors/Distributors.vue';
import VoucherCardsCards from './components/VoucherCards/Cards/Cards.vue';
import VoucherCardsTryAttemp from './components/VoucherCards/TryAttemp/TryAttemp.vue';
// (DistributorsVoucherCards was a second import of the SAME Distributors page —
//  the route now redirects to /VoucherCardsDistributors.)

//Users
import Users from './components/Users/Users.vue';
import UsersSuspend from './components/Users/Suspend/Suspend.vue';
import UsersProfile from './components/Users/Profile/Profile.vue';
import UsersNotifications from './components/Users/Notifications/Notifications.vue';
import SendNotificationByTarget from './components/Users/SendNotificationByTarget/SendNotificationByTarget.vue';
// Users/Parnets and Users/Teachers were four more copies of the Users list
// (same GET api/admin/Users/Get, no parent/teacher endpoint) — deleted.

//Dictionaries
import AcademicLevels from './components/Dictionaries/AcademicLevels/AcademicLevels.vue';
import AcademicSpecializations from './components/Dictionaries/AcademicSpecializations/AcademicSpecializations.vue';
import Faq from './components/Dictionaries/Faq/Faq.vue';
import NotificationsTypes from './components/Dictionaries/NotificationsTypes/NotificationsTypes.vue';
import PaymentMethods from './components/Dictionaries/PaymentMethods/PaymentMethods.vue';
import StudentsNotesTypes from './components/Dictionaries/StudentsNotesTypes/StudentsNotesTypes.vue';
// Dictionaries/SubscriptionsType (singular) was a duplicate CRUD of
// SubscriptionsTypes (plural) on the same endpoint — route redirects now.
import SubscriptionsTypes from './components/Dictionaries/SubscriptionsTypes/SubscriptionsTypes.vue';
import VehicleTypes from './components/Dictionaries/VehicleTypes/VehicleTypes.vue';
import TripCategories from './components/Dictionaries/TripCategories/TripCategories.vue';
import Cities from './components/Dictionaries/Cities/Cities.vue';
import Municipalities from './components/Dictionaries/Municipalities/Municipalities.vue';
import Locations from './components/Dictionaries/Locations/Locations.vue';
import Vehicles from './components/Vehicles/Vehicles.vue';

import SuspendedVehicles from './components/SuspendedVehicles/SuspendedVehicles.vue';

import SchoolsWalletsTracker from './components/Schools/Wallets/Tracker/Tracker.vue';

//Live Tracking (real-time map of all active trips — §9 of system rules)
import LiveTracking from './components/LiveTracking/LiveTracking.vue';

// Cameras — admin HLS live-stream gallery (CAM-09 / UI-13 / 2026-05-20).
// Reuses CameraPlayer.vue to render each active TripCameraStream (Status=1)
// through hls.js. Player itself fetches the per-trip short-lived JWT via
// GET /api/Cameras/Trip/{tripId}/Live and renders the m3u8 playlist.
import Cameras from './components/Cameras/Cameras.vue';

// Sprint A2 (Agent-A2 / 2026-05-20) — Eight new admin pages backing
// §2 (Pricing) / §3 (Cancellation) / §4 (SOS) / §7 (Withdraw) / §8
// (Schools) / §11 (Menu). These replace the ComingSoon placeholders
// the audit flagged in main.js lines 275-279.
import Pricing from './components/Pricing/Pricing.vue';
import PricingChangeLog from './components/PricingChangeLog/PricingChangeLog.vue';
import Sos from './components/Sos/Sos.vue';
import TrustedContacts from './components/TrustedContacts/TrustedContacts.vue';
import AdminNotifications from './components/AdminNotifications/AdminNotifications.vue';
import Reports from './components/Reports/Reports.vue';
import CancellationPolicy from './components/CancellationPolicy/CancellationPolicy.vue';
import SchoolInvoices from './components/SchoolInvoices/SchoolInvoices.vue';
import SchoolAttendanceReport from './components/SchoolAttendanceReport/SchoolAttendanceReport.vue';
import SmsSimulator from './components/SmsSimulator/SmsSimulator.vue';
// 2026-05-20 Agent A12: revenue dashboard with KPI cards + 3 charts. Previously
// orphaned (component existed but no route entry); wired in by main thread.
import RevenueDashboard from './components/RevenueDashboard/RevenueDashboard.vue';
// Audit P1 #10 — Commission Rules admin CRUD (super-admin only).
import CommissionRules from './components/CommissionRules/CommissionRules.vue';




Vue.use(VueEllipseProgress);

Vue.use(Vuetify)
Vue.use(VueI18n);
Vue.use(VueRouter);
//Vue.use(UploaderPlugin);
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

Vue.prototype.$http = DataService;
Vue.prototype.$blockUI = BlockUIService;
Vue.prototype.$helper = Helper;
Vue.prototype.$tripHub = TripChatHubService;


export const eventBus = new Vue();


const router = new VueRouter({
    mode: 'history',
    base: '/',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: { public: true },
        },
        {
            path: '/',
            component: App,
            children: [
                {
                    path: '',
                    component: Layout,
                    children: [
                        { path: 'ComingSoon', component: ComingSoon },

                        //Dashboard
                        { path: 'Home', component: Home },
                        { path: 'Cards', component: Cards },
                        { path: 'Charging', component: Charging },
                        { path: 'Events', component: Events },
                        // /Sales imported the very same RevenueDashboard component;
                        // kept as a redirect so old bookmarks/links still land right.
                        { path: 'Sales', redirect: '/RevenueDashboard' },
                        { path: 'Statistic', component: Statistic },
                        { path: 'LiveTracking', component: LiveTracking },
                        { path: 'Cameras', component: Cameras },
                        { path: 'SubscriptionsDashboard', component: SubscriptionsDashboard },
                        { path: 'WalletsDashboard', component: WalletsDashboard },
                        // Students
                        { path: 'Students', component: Students },
                        //Parents
                        { path: 'Parents', component: Parents },
                        //Schools
                        { path: 'Schools', component: Schools },
                        { path: 'SchoolsSuspend', component: SchoolsSuspend },
                        { path: 'SchoolsUsers', component: SchoolsUsers },
                        { path: 'SchoolsWallets', component: SchoolsWallets },
                        { path: 'SchoolsWalletsTracker', component: SchoolsWalletsTracker },
                        // Passengers
                        { path: 'Passengers', component: Passengers },
                        { path: 'SuspendedPassengers', component: SuspendedPassengers },
                        
                        //Classes
                        { path: 'Drivers', component: Drivers },
                        { path: 'SuspendedDrivers', component: SuspendedDrivers },
                        { path: 'DriversRatings', component: DriversRatings },

                        { path: 'Trips', component: Trips },
                        { path: 'CurrentRequests', component: CurrentRequests },
                        { path: 'CurrentTrips', component: CurrentTrips },
                        { path: 'SharedTrips', component: SharedTrips },
                        { path: 'SchoolTrips', component: SchoolTrips },
                        // Task 26 — dashboard in-progress card grid (auto-refresh 15s).
                        // Lazy-loaded because the dashboard already imports plenty.
                        { path: 'SchoolTripsLive', component: () => import('./components/SchoolTrips/LiveBoard.vue') },
                        { path: 'ScheduledTrips', component: ScheduledTrips },

                        //Contract trips (الرحلات التعاقدية) — super-admin only; each
                        // page enforces requireUserType([1]) in its own created().
                        { path: 'ContractRequests', component: ContractRequests },
                        { path: 'Contracts', component: Contracts },
                        { path: 'ContractCompanies', component: ContractCompanies },
                        { path: 'ContractPlanning', component: ContractPlanning },
                        { path: 'ContractTripsToday', component: ContractTripsToday },
                        { path: 'ContractInvoices', component: ContractInvoices },

                        //Financial — one page, two tabs (see FinancialHub.vue)
                        { path: 'Financial', component: FinancialHub },
                        { path: 'FinancialWithdrawing', component: FinancialHub },
                        { path: 'FinancialSubscriptions', component: FinancialSubscriptions },
                        { path: 'FinancialRecharge', component: FinancialRecharge },
                        { path: 'FinancialTracker', component: FinancialTracker },
                        { path: 'WalletPurchases', component: WalletPurchases },


                        //VoucherCards
                        { path: 'VoucherCards', component: VoucherCards },
                        { path: 'VoucherCardsDashboard', component: VoucherCardsDashboard },
                        { path: 'VoucherCardsDistributors', component: VoucherCardsDistributors },
                        { path: 'VoucherCardsCards', component: VoucherCardsCards },
                        { path: 'VoucherCardsTryAttemp', component: VoucherCardsTryAttemp },
                        { path: 'DistributorsVoucherCards', redirect: '/VoucherCardsDistributors' },

                        //Users
                        { path: 'Users', component: Users },
                        { path: 'UsersSuspend', component: UsersSuspend },
                        { path: 'UsersProfile', component: UsersProfile },
                        { path: 'UsersNotifications', component: UsersNotifications },
                        { path: 'SendNotificationByTarget', component: SendNotificationByTarget },

                        // Vehicles
                        { path: 'Vehicles', component: Vehicles },
                        { path: 'SuspendedVehicles', component: SuspendedVehicles },
                        
                        //Dictionaries
                        { path: 'AcademicLevels', component: AcademicLevels },
                        { path: 'AcademicSpecializations', component: AcademicSpecializations },
                        { path: 'Faq', component: Faq },
                        { path: 'NotificationsTypes', component: NotificationsTypes },
                        { path: 'PaymentMethods', component: PaymentMethods },
                        { path: 'StudentsNotesTypes', component: StudentsNotesTypes },
                        { path: 'SubscriptionsType', redirect: '/SubscriptionsTypes' },
                        { path: 'SubscriptionsTypes', component: SubscriptionsTypes },
                        { path: 'VehicleTypes', component: VehicleTypes },
                        { path: 'TripCategories', component: TripCategories },
                        { path: 'Cities', component: Cities },
                        { path: 'Municipalities', component: Municipalities },
                        { path: 'Locations', component: Locations },

                        // Sprint A2 (Agent-A2 / 2026-05-20) — Real Vue pages
                        // backing the §2/§3/§4/§7/§8/§11 system-rules areas.
                        // Replaces the ComingSoon placeholders called out by
                        // the 2026-05-19 audit (frontend at 20.6%).
                        { path: 'Pricing', component: Pricing },
                        { path: 'PricingChangeLog', component: PricingChangeLog },
                        { path: 'Sos', component: Sos },
                        { path: 'TrustedContacts', component: TrustedContacts },
                        { path: 'Reports', component: Reports },
                        { path: 'AdminNotifications', component: AdminNotifications },
                        { path: 'CancellationPolicy', component: CancellationPolicy },
                        { path: 'SchoolInvoices', component: SchoolInvoices },
                        { path: 'SchoolAttendanceReport', component: SchoolAttendanceReport },
                        // SMS Simulator dashboard (2026-05-20) — surfaces every OTP/SOS body
                        // the system would have sent in Live mode. Admin only.
                        { path: 'SmsSimulator', component: SmsSimulator },
                        // 2026-05-20 Agent A12: revenue dashboard (4 KPIs + 3 charts).
                        { path: 'RevenueDashboard', component: RevenueDashboard },
                        // Audit P1 #10 — commission-rate dial (super-admin only; gated in the page + menu).
                        { path: 'CommissionRules', component: CommissionRules },
                        // LE-027: real settings hub (was a ComingSoon placeholder, §11.3).
                        { path: 'Settings', component: GeneralSettings },

                        //Chat
                        //{ path: 'Chat', component: Chat },


                    ]
                },
            ],
        }
    ]
});

function hasClientSessionHint() {
    return !!localStorage.getItem('currentUser-client');
}

router.beforeEach((to, from, next) => {
    const authed = hasClientSessionHint();

    if (to.path === '/') {
        return next({ path: authed ? '/Home' : '/login', replace: true });
    }

    if (to.path === '/login' && authed) {
        return next({ path: '/Home', replace: true });
    }

    if (!authed && to.path !== '/login') {
        return next({ path: '/login', replace: true });
    }

    next();
});

Vue.filter('toUpperCase', function (value) {
    if (!value) return '';
    return value.toUpperCase();
});

new Vue({
    router,
    render: h => {
        return h(App);
    }
}).$mount('#cpanel-management');

// ─── كاشف التحديثات ───────────────────────────────────────────────────────
// المشكلة التي يحلّها: بعد كل نشر جديد يبقى التبويب المفتوح يشغّل النسخة
// القديمة، فيختبر المستخدم إصلاحاً «لا يعمل» وهو يعمل — حدث ذلك مرتين في يوم
// واحد (CurrentTrips ثم أزرار الرفض). أسماء ملفات الحزم تحمل بصمة تتغير مع كل
// بناء، وindex.html يُخدم بلا كاش، فنقارن بصمة الحزمة التي يشغّلها هذا التبويب
// بما يخدمه الخادم الآن؛ عند الاختلاف يظهر شريط «تحديث جديد» بزر تحديث واحد.
(function watchForNewBuild() {
    var current = (function () {
        var s = document.querySelector('script[src*="/js/app."]');
        var m = s && s.getAttribute('src').match(/app\.([0-9a-f]+)\.js/);
        return m ? m[1] : null;
    })();
    if (!current) return; // وضع التطوير (vite) — لا حزم مبصومة

    var shown = false;
    function check() {
        if (shown) return;
        fetch('/index.html?ts=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : null; })
            .then(function (html) {
                if (!html) return;
                var m = html.match(/js\/app\.([0-9a-f]+)\.js/);
                if (!m || m[1] === current) return;
                shown = true;
                var bar = document.createElement('div');
                bar.setAttribute('dir', 'rtl');
                bar.style.cssText = 'position:fixed;bottom:16px;inset-inline-start:16px;z-index:99999;' +
                    'background:#0B3FA8;color:#fff;padding:12px 18px;border-radius:12px;' +
                    'box-shadow:0 8px 24px rgba(0,0,0,.25);display:flex;gap:12px;align-items:center;' +
                    'font-family:inherit;font-size:14px';
                bar.innerHTML = '<span>صدر تحديث جديد للوحة — هذه النافذة تعرض نسخة قديمة.</span>' +
                    '<button style="background:#fff;color:#0B3FA8;border:0;border-radius:8px;' +
                    'padding:6px 14px;font-weight:700;cursor:pointer">تحديث الآن</button>';
                bar.querySelector('button').onclick = function () { location.reload(); };
                document.body.appendChild(bar);
            })
            .catch(function () { /* شبكة متقطعة — نحاول في الدورة التالية */ });
    }
    setInterval(check, 60000);
    // وأيضاً عند العودة للتبويب — أسرع لحظة يلاحظ فيها المستخدم أن شيئاً لا يعمل.
    document.addEventListener('visibilitychange', function () {
        if (!document.hidden) check();
    });
})();
